import * as detection from './Detection';

export const Detection = detection;
export { BODY_ID, DESKTOP_NAV_ID } from './Elements';
export { LIGHT_DARK } from './Themes';
export { FOOTER_DISCLAIMER_SECTIONS } from './Footer';
export { ENTER, TAB, UP, DOWN, ESC, HOME, END, SPACE, LEFT, RIGHT } from './Keys';
export { VIDEO_PLAYER } from './Modal';
